import React, { useEffect, useState } from 'react';
import TapArea from './TapArea';
import useOrbs from '../hooks/useOrbs';

const GUEST_SETTINGS = {
  orbColor: 'blue', selectedAnimal: 'cat', kidsMode: false,
  audioEnabled: true, audioVolume: 50, hapticsEnabled: true,
  orbSize: 3, orbSpacing: 40, reappearSpeed: 0.5,
};
const noop = () => {};
const formatTime = (seconds) => `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`;

export default function GuestFreeTap({ onSignIn }) {
  const [settings, setSettings] = useState(GUEST_SETTINGS);
  const [started, setStarted] = useState(false);
  const [secondsLeft, setSecondsLeft] = useState(null);
  const [complete, setComplete] = useState(false);
  const { orb1Visible, orb2Visible, orb1Color, orb2Color, handleOrbTap, resetOrbs } = useOrbs({
    settings, onTap: noop, onOrbReappeared: noop,
  });

  useEffect(() => {
    if (secondsLeft === null || secondsLeft <= 0) return undefined;
    const id = setInterval(() => setSecondsLeft(value => value === null ? null : Math.max(0, value - 1)), 1000);
    return () => clearInterval(id);
  }, [secondsLeft]);
  useEffect(() => {
    if (secondsLeft === 0) setComplete(true);
  }, [secondsLeft]);

  const begin = minutes => {
    resetOrbs();
    setSecondsLeft(minutes ? minutes * 60 : null);
    setComplete(false);
    setStarted(true);
  };

  if (!started) return (
    <main className="min-h-screen bg-black p-6 text-white flex items-center justify-center">
      <section className="w-full max-w-sm rounded-3xl border border-indigo-300/20 bg-slate-900 p-6 text-center">
        <h1 className="text-3xl font-bold">Free Tap</h1>
        <p className="mt-3 text-sm text-slate-300">Tap the blue and purple orbs at your own pace. No account needed.</p>
        <button type="button" onClick={() => begin(0)} className="mt-6 min-h-11 w-full rounded-xl bg-indigo-600 px-4 font-bold">Begin tapping</button>
        <p className="mt-5 text-xs text-slate-400">Or choose a session length</p>
        <div className="mt-2 grid grid-cols-3 gap-2">
          {[1, 5, 10].map(minutes => <button key={minutes} type="button" onClick={() => begin(minutes)} className="min-h-11 rounded-xl bg-white/10 text-sm">{minutes} min</button>)}
        </div>
        <button type="button" onClick={onSignIn} className="mt-6 min-h-11 w-full text-sm text-indigo-200 underline">Sign in or create an account for Pro and saved progress</button>
        <a href="https://taptap.org.uk/privacy/" target="_blank" rel="noopener noreferrer" className="mt-2 inline-block text-xs text-slate-300 underline">Privacy Policy</a>
      </section>
    </main>
  );

  return (
    <main className="h-screen w-full flex flex-col overflow-hidden bg-black text-white">
      <div className="flex items-center justify-between gap-3 px-4 py-3" style={{ paddingTop: 'calc(env(safe-area-inset-top, 0px) + 0.75rem)' }}>
        <button type="button" onClick={() => { setSecondsLeft(null); setStarted(false); }} className="min-h-11 rounded-full bg-white/10 px-4 text-sm">Back</button>
        <span className="text-sm font-semibold">{secondsLeft === null ? 'Free Tap' : formatTime(secondsLeft)}</span>
        <button type="button" onClick={() => setSettings(current => ({ ...current, audioEnabled: !current.audioEnabled }))} aria-pressed={settings.audioEnabled} className="min-h-11 rounded-full bg-white/10 px-4 text-sm">Sound {settings.audioEnabled ? 'On' : 'Off'}</button>
      </div>
      <TapArea
        kidsMode={false}
        orb1Visible={orb1Visible} orb2Visible={orb2Visible}
        orb1Color={orb1Color} orb2Color={orb2Color}
        orbSize={settings.orbSize} orbSpacing={settings.orbSpacing}
        onOrbTap={handleOrbTap} disabled={complete}
      />
      {complete && <div className="absolute inset-0 flex items-center justify-center bg-black/70 p-6">
        <div className="rounded-3xl border border-white/15 bg-slate-900 p-6 text-center">
          <h2 className="text-xl font-bold">Session complete</h2>
          <button type="button" onClick={() => begin(0)} className="mt-5 min-h-11 rounded-xl bg-indigo-600 px-5">Keep tapping</button>
          <button type="button" onClick={() => { setSecondsLeft(null); setStarted(false); }} className="mt-2 block min-h-11 w-full text-sm underline">Choose another session</button>
        </div>
      </div>}
    </main>
  );
}
